
import type {
  BaseErrorResponse,
  EmptySuccessResponse,
  GetLocalizationNamespacesRes,
  RefreshLocalizationsReq,
  UpdateNamespaceReq,
} from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function useLocalization() {
  class Localization<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Localization
     * @name LocalizationControllerGetNamespaces
     * @summary Getting a list of localization namespaces
     * @request GET:/api3/localization/namespace
     * @secure
     * @response `200` `GetLocalizationNamespacesRes`
     * @response `400` `BaseErrorResponse`
     */
    localizationControllerGetNamespaces = (
      query: {
        /**
         * @min 1
         * @max 500
         * @example 10
         */
        limit: number;
        /**
         * @min 0
         * @example 0
         */
        page: number;
        /** @example "platform.dictionary.*" */
        namespaceQuery?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetLocalizationNamespacesRes, BaseErrorResponse>({
        path: '/api3/localization/namespace',
        method: 'GET',
        query,
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Localization
     * @name LocalizationControllerUpdateNamespaces
     * @summary Updating a list of localization namespaces
     * @request PUT:/api3/localization/namespace
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    localizationControllerUpdateNamespaces = (data: UpdateNamespaceReq, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: '/api3/localization/namespace',
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Localization
     * @name LocalizationControllerRefreshLocalizations
     * @summary Refreshing a localization
     * @request POST:/api3/localization/refresh
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    localizationControllerRefreshLocalizations = (data: RefreshLocalizationsReq, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: '/api3/localization/refresh',
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });
  }

  return new Localization();
}
